import { AuthorBookList } from 'apiurl/author';
<template>
  <div class="chapterOption fr">
    <!-- 选择分卷，章节类型  发布，保存 -->
    <div class="chooselist clearfix">
      <div class="chooseroll fl chooseitem">
        分卷
        <el-select
          size="small"
          class="select"
          v-model="mainInfo.rollvalue"
          placeholder="请选择"
        >
          <el-option
            v-for="item in mainInfo.volumelist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="chooseroll fl chooseitem">
        章节类型
        <el-select
          size="small"
          class="select"
          v-model="mainInfo.chapterType"
          placeholder="请选择"
          @change="changeType"
        >
          <el-option
            v-for="item in mainInfo.typelist"
            :key="item.value"
            :label="item.desc"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="optionwrap fr">
        <button
          v-if="mainInfo.isSavebtn && !mainInfo.isSave"
          class="savebtn"
          @click="saveChapter('chapterContent')"
        >
          保存
        </button>
        <button
          v-if="!mainInfo.isSavebtn && !mainInfo.isSave"
          class="stillSave stillbtn"
        >
          仍要保存
        </button>
        <button
          v-if="mainInfo.isPubtn"
          class="publishbtn"
          @click="gocheckPub('chapterContent')"
        >
          发布
        </button>
        <button v-else class="stillPublish stillbtn">仍要发布</button>
        <button
          v-if="mainInfo.isDelBtn"
          class="delbtn"
          style="margin-left:16px"
          @click="isDel"
        >
          删除
        </button>
      </div>
    </div>
    <!-- 公告 -->
    <vue-seamless-scroll
      class="seamless-warp"
      :data="news"
      :class-option="optionLeft"
    >
      <p v-for="item in news" :key="item">
        {{ item }}
      </p>
    </vue-seamless-scroll>
    <el-form ref="chapterContent" :model="mainInfo" :rules="rules">
      <!-- 标题 -->
      <el-form-item prop="chapterTitle" class="chapterTBox">
        <el-input
          class="chapterTitle"
          placeholder="输入章节号或章节名，例：第一章 初次见面"
          v-model="mainInfo.chapterTitle"
        ></el-input>
      </el-form-item>
      <div class="mainbody">
        <!-- 章节内容 -->
        <el-form-item prop="mainCon" class="conbox">
          <el-input
            class="chapterCon"
            @input="getWordNum"
            type="textarea"
            placeholder="输入正文...
输入内容 请注意：
1、根据国家相关法律法规要求，请勿上传任何色情、低俗、涉政等违法违规内容，我们将会根据法规进行审核处理和上报；
2、请使用word等文本编辑工具撰写稿件，并务必备份稿件内容，防止由于网络原因丢失稿件无法找回；
3、为保障作品在渠道顺利推广，正文区禁止发布与正文无关的内容，章节名和作者的话请写在相对应的功能区。"
            v-model="mainInfo.mainCon"
          >
          </el-input>
        </el-form-item>
        <div class="wordbox clearfix">
          <span class="fl" @click="format(mainInfo.mainCon)">自动排版</span>
          <p class="fr">
            您已输入<span>{{ mainInfo.mainCount }}</span
            >字
          </p>
        </div>
        <el-form-item prop="authorCon">
          <el-input
            class="authorCon"
            type="textarea"
            placeholder="作者的话 （此段话不计入字数）"
            v-model="mainInfo.authorCon"
          >
          </el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { addChapter, editChapter } from "apiurl/author";
export default {
  props: {
    mainInfo: {
      type: Object,
      default: function() {
        return {
          mainCount: 0, // 字数
          mainCon: "", // 正文
          chapterTitle: "", //章节标题
          authorCon: "", //作者的话,
          volumelist: [],
          typelist: [],
          chapterType: "1",
          rollvalue: "0",
          isSavebtn: true,
          isPubtn: true,
          pubTime: ""
        };
      }
    },
    newChapter: String,
    isDrag: Boolean
  },
  data() {
    var validatetitle = (rule, value, callback) => {
      let str = this.mainInfo.chapterTitle.replace(/\s*/g, "");
      if (str.length > 0) {
        callback();
      } else {
        callback(new Error("章节标题不能为空"));
      }
    };
    var validateCon = (rule, value, callback) => {
      if (this.mainInfo.mainCount > 1500) {
        callback();
      } else {
        callback(new Error("内容不得少于1500"));
      }
    };
    var validateAu = (rule, value, callback) => {
      if (this.authorCon.length < 200) {
        callback();
      } else {
        callback(new Error("内容不得多于200"));
      }
    };
    return {
      news: [
        "公告：近期接到第三方渠道投诉，请作者勿在章节正文内添加个人微信号、qq群、qq号等联系方式，违者被发现将扣除当月全勤！"
      ],
      ischeckCon: [
        { required: true, message: "*请输入章节内容", trigger: "blur" },
        { validator: validateCon, trigger: "blur" }
      ],
      chapterTitle: "", //章节标题
      authorCon: "", //作者的话,
      rules: {
        chapterTitle: [
          { required: true, message: "*请输入章节标题", trigger: "blur" },
          { validator: validatetitle, trigger: "blur" }
        ],
        mainCon: [
          { required: true, message: "*请输入章节内容", trigger: "blur" },
          { validator: validateCon, trigger: "blur" }
        ],
        authorCon: [{ validator: validateAu, trigger: "blur" }]
      }
    };
  },
 /*  watch: {
    mainInfo: {
      handler(newName) {
        if (newName.chapterType == "3") {
          this.rules.mainCon = this.rules.mainCon.slice(0, 1);
        } else {
          this.rules.mainCon = this.ischeckCon;
        }
      },
      deep: true
    }
  }, */
  create() {},
  methods: {
    // 计算字数
    getWordNum() {
      this.mainInfo.mainCount = this.mainInfo.mainCon.trim().length;
    },
    changeType() {
      if (this.mainInfo.chapterType == "3") {
        this.rules.mainCon = this.rules.mainCon.slice(0, 1);
      }
    },
    // 自动排版函数
    format(content) {
      var lines = content.split("(\n\r)|(\n)"),
        line = null,
        i = 0,
        allLine = [];
      for (var len = lines.length; i < len; i++) {
        // eslint-disable-next-line no-redeclare
        var line = lines[i];
        if (line == "") {
          allLine.push("\n\r");
        } else {
          allLine.push(replaceSpace(line));
        }
      }

      function replaceSpace(str) {
        var links = str.match(/(<a\b[^>]+>(.*?)<\/a>)/gi),
          links2 = [];
        str =
          "\u3000\u3000" +
          str
            .replace(/[ \u3000\t\r]/g, "")
            .replace(/[\n]+/g, "\r\n\u3000\u3000");
        if (links && links.length) {
          links2 = str.match(/(<a[^>]+>(.*?)<\/a>)/gi);
          for (var i = 0, len = links2.length; i < len; i++) {
            str = str.replace(links2[i], links[i]);
          }
        }
        return str;
      }

      this.mainInfo.mainCon = allLine.join("");
    },
    /* 添加章节 */
    saveChapter(chapterContent) {
      var main = this.mainInfo;
      this.format(main.mainCon);
      this.rules.mainCon = this.rules.mainCon.slice(0, 1);
      this.$refs[chapterContent].validate(valid => {
        if (valid) {
          let data = {
            bookId: this.$route.params.id,
            additional: main.authorCon,
            content: main.mainCon,
            freeType: main.chapterType,
            name: main.chapterTitle,
            submitType: "save",
            volumeId: main.rollvalue
          };
          if (this.$route.name === "草稿箱") {
            data.chapterId = this.newChapter;
            editChapter(this.qs.stringify(data))
              .then(res => {
                this.successOption(res);
              })
              .catch(() => {});
          } else {
            addChapter(this.qs.stringify(data))
              .then(res => {
                this.successOption(res);
              })
              .catch(() => {});
          }
        }
      });
    },
    // 成功验证
    successOption(res) {
      if (res.success) {
        if (this.$route.name === "草稿箱") {
          this.$emit("changeChs", true);
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.$emit("successsave");
        } else {
          this.$message({
            message: "章节已保存至草稿箱",
            type: "success"
          });
          this.$emit("mainInfoChange", {
            mainCount: 0, // 字数
            mainCon: "", // 正文
            chapterTitle: "", //章节标题
            authorCon: "", //作者的话,
            chapterType: "1",
            rollvalue: "0",
            isSavebtn: true,
            isPubtn: true
          });
        }
      }
    },
    //点击发布按钮
    gocheckPub(chapterContent) {
      var main = this.mainInfo;
      this.format(main.mainCon);
      if (this.mainInfo.chapterType !== "3") {
        this.rules.mainCon = this.ischeckCon;
      } else {
        this.rules.mainCon = this.rules.mainCon.slice(0, 1);
      }

      this.$refs[chapterContent].validate(valid => {
        if (valid) {
          this.$emit("checkSuccess", true);
        }
      });
    },
    // 删除
    isDel() {
      this.$emit("delChapter", true);
    }
  },
  computed: {
    // 无缝滚动
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 0
      };
    }
  },
  mounted() {}
};
</script>

<style>
.select .el-input--suffix .el-input__inner {
  width: 100px;
  height: 24px;
  line-height: 24px;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #48a2df;
}
.el-select .el-input__inner:focus {
  border-color: #48a2df;
}
.el-select-dropdown__item.selected {
  color: #48a2df;
}
.select .el-input--small .el-input__icon {
  line-height: 24px;
}

.chapterTitle .el-input__inner::placeholder {
  color: #bcbcbc;
  font-size: 14px;
}
.chapterTitle.el-input {
  height: 40px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 6px 0px rgba(216, 216, 216, 0.5);
  border-radius: 20px;
  border: 1px solid rgba(211, 211, 211, 1);
}
.chapterTBox .el-form-item__error {
  right: 43px;
  top: 50%;
  margin-top: -8px;
  left: auto;
}
.conbox .el-form-item__error {
  right: 24px;
  top: -20px;
  left: auto;
}
.chapterTitle .el-input__inner {
  width: 65%;
  border: none;
  margin: 2px 5px;
  height: 32px;
  line-height: 32px;
}

.chapterTitle .el-form-item__content {
  border: 1px solid rgba(211, 211, 211, 1);
  height: 500px;
  letter-spacing: 5px;
  border-radius: 0px;
  line-height: 20px;
  border: none;
}
.chapterCon .el-input__inner::placeholder {
  color: #bcbcbc;
  font-size: 14px;
}
.chapterCon .el-textarea__inner {
  border: 1px solid rgba(211, 211, 211, 1);
  height: 500px;
  letter-spacing: 5px;
  border-radius: 0px;
  line-height: 20px;
  border: none;
}
.authorCon .el-textarea__inner {
  border: 1px solid rgba(211, 211, 211, 1);
  height: 80px;
  border-radius: 0px;
  border: none;
  letter-spacing: 5px;
  border-radius: 0px;
  line-height: 20px;
}
.el-textarea__inner {
  resize: none;
}
.chooselist .el-select-dropdown__item {
  height: 24px;
  line-height: 24px;
}
.chapterOption .el-form-item {
  margin-bottom: 0px;
}
</style>
<style lang="stylus" scoped>
.chapterOption
    width 790px
    box-sizing border-box
    position relative
    border-left 1px solid rgba(211, 211, 211, 1)
    .chooselist
        padding 20px 16px
        .chooseroll
            margin-right 24px
        .chooseitem
            font-size 14px
            .el-select
                margin-left 8px
    .optionwrap
        button
            padding 0px 10px
            font-size 14px
            height 24px
            color rgba(136, 136, 136, 1)
            background #fff
            line-height 24px
            text-align center
            border 1px solid #d3d3d3
            border-radius 4px
            &:hover
                border-color #48A2DF
                color #48A2DF
            &.savebtn
                margin-right 16px
            &.stillbtn
                background #38C878
                color #fff
                border none
            &.stillSave
                margin-right 16px
    .seamless-warp
        margin 0 16px
        overflow hidden
        p
            font-size 12px
            height 17px
            line-height 17px
            color rgba(255, 107, 56, 1)
    .chapterTitle
        margin 20px 16px
        width 744px
    .mainbody
        border 1px solid rgba(211, 211, 211, 1)
        border-bottom none
        margin 0px 16px 0
        .chapterCon
            width 744px
        .authorCon
            width 744px
        .wordbox
            width 712px
            height 40px
            background rgba(238, 238, 238, 1)
            color #48A2DF
            font-size 14px
            line-height 40px
            padding 0 16px
            span
                cursor pointer
</style>
